module.exports = __webpack_public_path__ + "static/media/orthFamily.905bc1d5.png";